import { combineReducers } from "redux";
import { initialReducer } from "./initialReducer";
import { commonReducer } from "./commonReducer";
import { productOffersReducer } from "./productOffers";

const rootReducer = combineReducers({
  initialReducer,
  commonReducer,
  productOffersReducer,
});
export default rootReducer;
